import type { Interpolation, Theme } from '@emotion/react';
import { Box, COLOR_PALETTE, NavLink, type NavLinkProps } from '@inflearn/ds-react-next';
import { useRouter } from 'next/router';
import { GameButton } from '../../../../components/pages/games/entry/GameButton';
import { useSidebarLinks } from './useSidebarLinks';

export function Sidebar({
  styles,
}: {
  styles?: {
    root?: Interpolation<Theme>;
  };
}) {
  const router = useRouter();
  const sidebarLinks = useSidebarLinks();

  return (
    <Box css={styles?.root}>
      {sidebarLinks.map(({ isActive: checkIsActive, ...link }) => {
        const isActive = checkIsActive(router.asPath);

        return <SidebarNavLink key={link.label} {...link} active={isActive} />;
      })}
      <GameButton />
    </Box>
  );
}

function SidebarNavLink(props: NavLinkProps & { isExternal?: boolean; href: string }) {
  const router = useRouter();
  const { isExternal, href, active, ...restProps } = props;

  const navLinkStyles = {
    root: {
      padding: '12px 16px',
      height: '49px',
      borderRadius: '8px',
    },
    label: {
      fontSize: '16px',
      fontWeight: 400,
    },
    icon: {
      color: active ? COLOR_PALETTE.infgreen[8] : COLOR_PALETTE.gray[7],
    },
  };

  if (isExternal) {
    return (
      <NavLink
        component="a"
        href={href}
        target="_blank"
        variant="light"
        styles={navLinkStyles}
        active={active}
        {...restProps}
      />
    );
  }

  return (
    <NavLink
      component="a"
      target="_self"
      href={href}
      variant="light"
      styles={navLinkStyles}
      active={active}
      onClick={(e: React.MouseEvent<HTMLAnchorElement>) => {
        // Allow opening in new tab with Cmd/Ctrl + click
        if (e.metaKey || e.ctrlKey) {
          return;
        }
        e.preventDefault();
        router.push(href);
      }}
      {...restProps}
    />
  );
}
